import React, { useCallback, useState, useEffect, useRef } from 'react';

import styled from 'styled-components';

import useCioAutosuggest from '../hooks/useCioAutosuggest';

import CioDesktopInput from './CioDesktopInput';
import CioDesktopOverlay from './CioDesktopOverlay';

const SearchWrapper = styled.div``;

const openAnimation = 'openOverlay 200ms ease-out forwards';
const closeAnimation = 'closeOverlay 200ms ease-in forwards';

const CioSearchBar = () => {
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const [animation, setAnimation] = useState('none');
  const { setCloseOverlay, inputValue, setInputValue } = useCioAutosuggest();
  const inputRef = useRef();

  const setOverlay = useCallback((isOpen) => {
    setIsOverlayOpen(isOpen);
    setAnimation(isOpen ? openAnimation : closeAnimation);
  }, []);

  useEffect(() => {
    setCloseOverlay(() => () => setOverlay(false));
  }, [setCloseOverlay, setOverlay]);

  return (
    <SearchWrapper>
      <CioDesktopInput
        animation={animation}
        setOverlay={setOverlay}
        searchValue={inputValue}
        setSearchValue={setInputValue}
        inputRef={inputRef}
      />
      {isOverlayOpen && (
        <CioDesktopOverlay inputRef={inputRef} setOverlay={setOverlay} />
      )}
    </SearchWrapper>
  );
};

export default CioSearchBar;
